document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) return;

  const getItems = () => {
    return Array.from(gallery.querySelectorAll('.product-gallery__item'));
  };

  let currentIndex = 0;
  let isModalOpen = false;
  let lastMouseX = 0;

  const modal = document.createElement('div');
  modal.className = 'product-gallery__modal';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('tabindex', '0');

  const modalContent = document.createElement('div');
  modalContent.className = 'product-gallery__modal-content';

  const modalImg = document.createElement('img');
  modalImg.className = 'product-gallery__modal-img';
  modalImg.setAttribute('role', 'presentation');

  modalContent.appendChild(modalImg);
  modal.appendChild(modalContent);
  document.body.appendChild(modal);

  const openModal = (index) => {
    const items = getItems();
    const img = items[index].querySelector('.product-image');
    if (!img) return;

    modalImg.src = img.src;
    modalImg.setAttribute('alt', img.getAttribute('alt') || '');
    modal.classList.add('is-active');
    isModalOpen = true;
    document.body.style.overflow = 'hidden';

    modal.focus();
  };

  const closeModal = () => {
    modal.classList.remove('is-active');
    isModalOpen = false;
    document.body.style.overflow = '';
  };

  const updateModalImage = (index) => {
    const items = getItems();
    const img = items[index].querySelector('.product-image');
    if (!img) return;

    modalImg.src = img.src;
    modalImg.setAttribute('alt', img.getAttribute('alt') || '');
  };

  const activate = (i) => {
    const items = getItems();
    const index = Math.max(0, Math.min(i, items.length - 1));
    currentIndex = index;

    if (isModalOpen) {
      updateModalImage(index);
      updateCursor(lastMouseX);
    }
  };

  const isMobile =
    window.__isMobile ||
    (() => {
      return (
        window.innerWidth <= 1024 ||
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      );
    });

  activate(0);

  gallery.addEventListener('click', (e) => {
    const clickedItem = e.target.closest('.product-gallery__item');
    if (!clickedItem) return;

    if (isMobile()) {
      return;
    }

    const items = getItems();
    const index = items.indexOf(clickedItem);
    if (index === -1) return;

    activate(index);
    openModal(index);
  });

  const updateCursor = (clientX) => {
    if (!isModalOpen || clientX === undefined) return;

    const items = getItems();
    const modalRect = modal.getBoundingClientRect();
    const mouseX = clientX;
    const centerX = modalRect.left + modalRect.width / 2;

    if (mouseX < centerX) {
      if (currentIndex === 0) {
        modal.style.cursor = 'default';
      } else {
        modal.style.cursor = 'w-resize';
      }
    } else {
      if (currentIndex === items.length - 1) {
        modal.style.cursor = 'default';
      } else {
        modal.style.cursor = 'e-resize';
      }
    }
  };

  modal.addEventListener('mousemove', (e) => {
    if (e.target === modalImg) {
      return;
    }

    lastMouseX = e.clientX;
    updateCursor(e.clientX);
  });

  modal.addEventListener('mouseleave', () => {
    modal.style.cursor = '';
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modalImg) {
      closeModal();
      return;
    }

    const items = getItems();
    const modalRect = modal.getBoundingClientRect();
    const clickX = e.clientX;
    const centerX = modalRect.left + modalRect.width / 2;

    if (clickX < centerX) {
      if (currentIndex > 0) {
        activate(currentIndex - 1);
      }
    } else {
      if (currentIndex < items.length - 1) {
        activate(currentIndex + 1);
      }
    }
  });

  modal.addEventListener('keydown', (e) => {
    const items = getItems();
    if (e.key === 'Escape') {
      closeModal();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      if (currentIndex > 0) {
        activate(currentIndex - 1);
      }
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      if (currentIndex < items.length - 1) {
        activate(currentIndex + 1);
      }
    }
  });

  let modalStartX = 0;
  let modalDeltaX = 0;

  modal.addEventListener(
    'touchstart',
    (e) => {
      modalStartX = e.touches[0].clientX;
      modalDeltaX = 0;
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchmove',
    (e) => {
      modalDeltaX = e.touches[0].clientX - modalStartX;
    },
    { passive: true }
  );

  modal.addEventListener(
    'touchend',
    () => {
      const items = getItems();
      if (Math.abs(modalDeltaX) > 40) {
        let nextIndex;
        if (modalDeltaX < 0) {
          if (currentIndex < items.length - 1) {
            nextIndex = currentIndex + 1;
            activate(nextIndex);
          }
        } else {
          if (currentIndex > 0) {
            nextIndex = currentIndex - 1;
            activate(nextIndex);
          }
        }
      }
    },
    { passive: true }
  );
});
